import React from 'react';
import { useSetCurrentPage } from '../stores/useAppStore';

const HiddenMenu: React.FC = () => {
  const setCurrentPage = useSetCurrentPage();

  return (
    <div className="absolute right-6 z-[2000] flex flex-col gap-3 pointer-events-auto" style={{ top: '2rem' }}>
      <button
        onClick={() => setCurrentPage('personal-center')}
        className="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-sm border border-white/20 rounded-full flex items-center justify-center text-white hover:from-blue-500/30 hover:to-purple-500/30 hover:border-white/30 transition-all duration-300 hover:scale-105 shadow-lg"
        aria-label="打开个人中心"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      </button>

      <button
        onClick={() => setCurrentPage('stock-dashboard')}
        className="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-sm border border-white/20 rounded-full flex items-center justify-center text-white hover:from-blue-500/30 hover:to-purple-500/30 hover:border-white/30 transition-all duration-300 hover:scale-105 shadow-lg"
        title="切换至A股版面"
        aria-label="切换至A股版面"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      </button>
    </div>
  );
};

export default HiddenMenu;
